import { render, staticRenderFns } from "./BookVersionMessage.vue?vue&type=template&id=1d135912&scoped=true"
import script from "./BookVersionMessage.vue?vue&type=script&lang=js"
export * from "./BookVersionMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d135912",
  null
  
)

export default component.exports